import React,{ useLayoutEffect, useRef } from 'react'
import './sliderpre.css'
import ImageSlider from '../../../FinalOutput/Components/Slider-prewedding/ImageSlider';
import PreWeddingVideo from '../../../FinalOutput/Components/Slider-prewedding/PreWeddingVideo';
import { gsap } from 'gsap'

const Sliderpre = ({ details,photoMode }) => {
     const sectionRef = useRef(null)
      const topFrameRef = useRef(null)
      const bottomFrameRef = useRef(null)

      
             useLayoutEffect(() => {
          
              const ctx = gsap.context(() => {
          
                if (!sectionRef.current) return
          
                const topFrame = topFrameRef.current
                const bottomFrame = bottomFrameRef.current
          
                if (!topFrame && !bottomFrame) return
          
                const frames = [
                  topFrame,
                  bottomFrame
                ].filter(Boolean)
          
                gsap.from(frames, {
                  autoAlpha: 0,
                  y: (index) => index === 0 ? -8 : 8,
                  duration: 1.1,
                  stagger: 0.08,
                  ease: "power2.out",
          
                  scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 65%",
                    once: true,
                  },
                })
          
              }, sectionRef)
          
              return () => ctx.revert()
          
            }, [])

  const images = details?.footerImages || [];
  const preWeddingLink = details?.preWeddingLink?.trim();

  const hasImages = images.length > 0;
  const hasPreWedding = !!preWeddingLink;

  //  const isPhotoCouple = details?.coupleType === "photoCouple";
    const databaseHasPhoto = details?.coupleType === "photoCouple";

  const hasPhoto =
    photoMode === "photo"
      ? true
      : photoMode === "no-photo"
      ? false
      : databaseHasPhoto;

  const sectionClass = hasPhoto
    ? "t2-slider-section photo-couple"
    : "t2-slider-section other-couple";

      const topFrame = hasPhoto
    ? "/theme2-photo-slider-frame.png"
    : "/theme2-nophoto-slider-frame.png";

  const bottomFrame = hasPhoto
    ? "/theme2-photo-slider-frame.png"
    : "/theme2-nophoto-slider-frame.png";

  if (!hasImages && !hasPreWedding) {
    return null;
  }



  return (
    <section
    ref={sectionRef}
     className={`${sectionClass}
        ${details?.theme || ''}
        ${hasPreWedding ? "has-prewedding" : ""}`}
    >


      {/* Top frame */}
      <img
       ref={topFrameRef} 
        src={topFrame}
        className="t2-slider-frame t2-slider-frame-top"
        alt=""
      />

  

      {/* Bottom frame */}
      <img
      ref={bottomFrameRef}
        src={bottomFrame}
        className="t2-slider-frame t2-slider-frame-bottom"
        alt=""
      />

  <div className="t2-slider-content">
      {hasImages &&  <ImageSlider  images={images}  /> }

      {preWeddingLink &&  <PreWeddingVideo   link={preWeddingLink}  /> }
</div>
    </section>
  )
}

export default Sliderpre